export default __webpack_public_path__ + "static/media/SERVICE24.9657648a.png";